<div class="layout-row layout-align-start-center full-height gap-10">
  <div class="layout-row text-ellipsis"
       *ngFor="let label of viewLabels">
    <app-bringoz-tag [name]="label"
                     [backgroundColor]="labelsMap[label]?.color">
    </app-bringoz-tag>
  </div>

  <div *ngIf="extraLabelsCount" class="margin-left-5 counter-container"
       [ngbTooltip]="labelTooltip" openDelay="300" triggers="hover">
    <span class="br-body-2">+{{extraLabelsCount}}</span>
  </div>

  <ng-template #labelTooltip>
    <div class="layout-column layout-align-center-start gap-5">
      <app-bringoz-tag *ngFor="let label of extraLabels"
                       [name]="label"
                       [backgroundColor]="labelsMap[label]?.color">
      </app-bringoz-tag>
    </div>
  </ng-template>

</div>

